import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import useTranslation from '../../../../hooks/useTranslations';
import { selectBusinessAreaById } from '../../../../redux/modules/data/businessAreasSlice';
import { selectFolderById } from '../../../../redux/modules/data/foldersSlice';
import { selectEvaluationCategories, selectOrderedEvaluationsByFolderId } from '../../../../redux/modules/evaluationsSlice';
import { AlertIcon } from '../../../misc/icons/Icons';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import { PopoverNavItem } from '../../layouts/partials/PopupWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import TableWrapper from '../../layouts/partials/TableWrapper';
import PrivateLayout from '../../layouts/PrivateLayout';
import EvaluationRow from './partials/EvaluationRow';

const EvaluationsScreen = () => {
	const t = useTranslation();

	const { baId } = useParams();
	const businessArea = useSelector((state) => selectBusinessAreaById(state, baId));

	const breadcrumb = [
		{ route: baId, translationKey: businessArea.translationkey },
		{ route: `${baId}/evaluations`, translationKey: 'eval_app_evaluations' },
	];

	// TODO: Kann man das mit besseren Selektoren einfacher lösen?
	const evaluationFolder = useSelector((state) => selectFolderById(state, businessArea.evaluationAppFolderId));
	const evaluationCategories = useSelector((state) => selectEvaluationCategories(state, evaluationFolder.children));
	const evaluationsPopoverItems = evaluationCategories?.map((evaluationCategory) => (
		<PopoverNavItem
			key={evaluationCategory.id}
			title={evaluationCategory.translationkey}
			route={`/${baId}/evaluations/${evaluationCategory.id}`}
		/>
	));

	const evaluations = useSelector((state) => selectOrderedEvaluationsByFolderId(state, businessArea.evaluationAppFolderId));

	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={t('eval_app_evaluations')} customTree={breadcrumb}>
				<div className="text-white border border-white text-[0.84375rem] lg:text-[1.0625rem] mb-6 lg:my-24 px-4 lg:px-5 py-2 lg:py-3 -mx-5 max-w-xs">
					<div className="flex justify-between">
						<span className="font-bold">
							{t('webapp_favs_note_headline')}
						</span>
						<AlertIcon className="flex-shrink-0 w-5 h-5 ml-2 -mr-2 lg:-mt-1 lg:w-6 lg:h-6 text-oly-red-default" />
					</div>
					<p>
						{t('webapp_eval_note_text')}
					</p>
				</div>
			</SidebarWrapper>
			<ContentWrapper>
				<TableWrapper buttons={[{ id: 1, title: t('eval_app_new_evaluation'), popoverItems: evaluationsPopoverItems }]} title={!evaluations?.length > 0 ? t('eval_app_no_evaluations_found') : ''}>
					{evaluations?.length > 0 && (
						<div className="border-t-0.5 border-b-0.5 divide-y divide-oly-gray-light border-oly-gray-light">
							{evaluations.map((evaluation) => <EvaluationRow key={evaluation.id} evaluation={evaluation} />)}
						</div>
					)}
				</TableWrapper>
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default EvaluationsScreen;
